import React from "react"
import { Link } from "gatsby"

export const Nav = () => {
  return (
    <header className="text-gray-400 bg-gray-900 body-font ">
      <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center max-height:32">
        <Link
          className="flex title-font font-medium items-center text-white mb-4 md:mb-0 no-underline"
          href="/"
          to="/"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            className="w-10 h-10 text-white p-2 bg-red-500 rounded-full"
            viewBox="0 0 24 24"
          >
            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
          </svg>
          <span className="ml-3 text-xl">
            Ruairidh <span className="animate-pulse">Codes</span>
          </span>
        </Link>
        <nav className="md:ml-auto flex flex-wrap items-center text-base justify-center">
          <Link className="mr-5 hover:text-white" href="/about" to="/about">
            About
          </Link>
          <Link className="mr-5 hover:text-white" href="/cv" to="/cv">
            CV
          </Link>
        </nav>
        <a
          className="mr-5 hover:text-white"
          href="mailto:ruairidh@ruairidh.dev?Subject=Message from your blog"
        >
          <button className="inline-flex items-center bg-gray-800 border-0 py-1 px-3 focus:outline-none hover:bg-gray-700 rounded text-base mt-4 md:mt-0">
            Contact
            <svg
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              className="w-4 h-4 ml-1"
              viewBox="0 0 24 24"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        </a>
      </div>
    </header>
  )
}
